import { useMemo } from "react";
import { getGQL } from "utils/utils";
import { COLUMN_HEADERS } from "services/graphQL/ciq-queries";
import { FeatureTypesIndex } from "../constants";
import { useCIQQuery } from "./ciq-gql-hooks";

export const useSubmittalMaterialLogsHeaders = (gqlClientForProject: any) => {
  const { query: qColumnHeaders } = useMemo(() => {
    return getGQL(COLUMN_HEADERS);
  }, []);
  const { data: responseData, refetch } = useCIQQuery(qColumnHeaders, {
    client: gqlClientForProject,
    skip: !gqlClientForProject
  });

  const columnHeaders = useMemo(() => {
    let submittalHeadersMap: any = {};
    let materialHeadersMap: any = {};
    let bidPackageHeadersMap: any = {};
    let designPackageHeadersMap: any = {};
    let designScopeHeadersMap: any = {};

    if (
      responseData?.project_feature_configurations &&
      responseData?.project_feature_configurations?.length > 0
    ) {
      const resArr: any[] = responseData?.project_feature_configurations;

      submittalHeadersMap = resArr.find(
        (obj) => obj.feature_id === FeatureTypesIndex.SUBMITTAL
      );
      materialHeadersMap = resArr.find(
        (obj) => obj.feature_id === FeatureTypesIndex.MATERIAL
      );
      bidPackageHeadersMap = resArr.find(
        (obj) => obj.feature_id === FeatureTypesIndex.BID_PACKAGE
      );
      designPackageHeadersMap = resArr.find(
        (obj) => obj.feature_id === FeatureTypesIndex.DESIGN_PACKAGE
      );
      designScopeHeadersMap = resArr.find(
        (obj) => obj.feature_id === FeatureTypesIndex.DESIGN_SCOPE
      );

      const submittalHeaderMap: any = {};
      submittalHeadersMap?.field_mapping?.forEach((columnData: any) => {
        const key = columnData?.field_name;
        submittalHeaderMap[key] = columnData?.caption_en;
      });

      const submittalCustomColumns: any = [];
      submittalHeadersMap?.field_mapping?.forEach((columnData: any) => {
        if (columnData?.is_custom) {
          submittalCustomColumns.push({
            headerName: columnData?.caption_en,
            field: columnData?.field_name,
            field_type: columnData?.field_type
          });
        }
      });

      const materialHeaderMap: any = {};
      materialHeadersMap?.field_mapping?.forEach((columnData: any) => {
        const key = columnData?.field_name;
        materialHeaderMap[key] = columnData?.caption_en;
      });

      const materialCustomColumns: any = [];
      materialHeadersMap?.field_mapping?.forEach((columnData: any) => {
        if (columnData?.is_custom) {
          materialCustomColumns.push({
            headerName: columnData?.caption_en,
            field: columnData?.field_name,
            field_type: columnData?.field_type
          });
        }
      });

      const bidPackageHeaderMap: any = {};
      bidPackageHeadersMap?.field_mapping?.forEach((columnData: any) => {
        const key = columnData?.field_name;
        bidPackageHeaderMap[key] = columnData?.caption_en;
      });

      const bidPackageCustomColumns: any = [];
      bidPackageHeadersMap?.field_mapping?.forEach((columnData: any) => {
        if (columnData?.is_custom) {
          bidPackageCustomColumns.push({
            headerName: columnData?.caption_en,
            field: columnData?.field_name,
            field_type: columnData?.field_type
          });
        }
      });

      const designPackageHeaderMap: any = {};
      designPackageHeadersMap?.field_mapping?.forEach((columnData: any) => {
        const key = columnData?.field_name;
        designPackageHeaderMap[key] = columnData?.caption_en;
      });

      const designPackageCustomColumns: any = [];
      designPackageHeadersMap?.field_mapping?.forEach((columnData: any) => {
        if (columnData?.is_custom) {
          designPackageCustomColumns.push({
            headerName: columnData?.caption_en,
            field: columnData?.field_name,
            field_type: columnData?.field_type
          });
        }
      });

      const designScopeHeaderMap: any = {};
      designScopeHeadersMap?.field_mapping?.forEach((columnData: any) => {
        const key = columnData?.field_name;
        designScopeHeaderMap[key] = columnData?.caption_en;
      });

      return {
        submittalHeaders: submittalHeadersMap,
        materialHeaders: materialHeadersMap,
        submittalHeaderMap,
        submittalCustomColumns,
        materialHeaderMap,
        materialCustomColumns,
        bidPackageHeaders: bidPackageHeadersMap,
        designPackageHeaders: designPackageHeadersMap,
        bidPackageHeaderMap,
        designPackageHeaderMap,
        designPackageCustomColumns,
        bidPackageCustomColumns,
        designScopeHeaders: designScopeHeadersMap,
        designScopeHeaderMap
      };
    }
    return {
      submittalHeaders: null,
      materialHeaders: null,
      submittalHeaderMap: {},
      submittalCustomColumns: [],
      materialHeaderMap: {},
      materialCustomColumns: [],
      bidPackageHeaders: null,
      designPackageHeaders: null,
      bidPackageHeaderMap: {},
      designPackageHeaderMap: {},
      designPackageCustomColumns: [],
      bidPackageCustomColumns: [],
      designScopeHeaders: null,
      designScopeHeaderMap: {}
    };
  }, [responseData]);

  return { columnHeaders, refetch };
};
